import React from "react"
import { observer } from "mobx-react"

import InputTitle from "./InputTitle"
import Spacer from "~/components/Spacer"
import Dropdown from "~/components/Form/Dropdown"
import useInject from "~/hooks/useInject"

export const VA_REGIONS = {
  "Northern Virginia": [
    "Alexandria", "Arlington", "Clarke", "Culpeper", "Fairfax City",
    "Fairfax County", "Falls Church", "Fauquier", "Frederick",
    "Fredericksburg", "King George", "Loudoun", "Prince William",
    "Rappahannock", "Spotsylvania", "Stafford", "Warren", "Winchester",
  ],
  "Shenandoah Valley": [
    "Augusta", "Bath", "Buena Vista", "Harrisonburg/Rockingham",
    "Highland", "Lexington/Rockbridge", "Page", "Shenandoah",
    "Staunton", "Waynesboro",
  ],
  "Central Virginia": [
    "Albemarle", "Charlottesville", "Fluvanna", "Greene", "Louisa",
    "Madison", "Nelson", "Orange",
  ],
  "Lynchburg Area": [
    "Amherst", "Appomattox", "Bedford", "Buckingham", "Campbell",
    "Cumberland", "Lynchburg",
  ],
  "Richmond Metro": [
    "Charles City", "Chesterfield", "Colonial Heights", "Dinwiddie",
    "Goochland", "Hanover", "Henrico", "Hopewell", "New Kent",
    "Petersburg", "Powhatan", "Prince George", "Richmond City",
    "Richmond-Civil", "Richmond-Marsh Criminal/Traffic",
    "Richmond-John Marshall Criminal/Traffic", "Richmond Manchester",
  ],
  "Hampton Roads": [
    "Chesapeake", "Gloucester", "Hampton", "Isle of Wight", "Mathews",
    "Newport News-Civil", "Newport News-Criminal", "Newport News-Traffic",
    "Norfolk", "Norfolk-Criminal Division", "Norfolk-Traffic Division",
    "Norfolk-Civil Division", "Portsmouth", "Suffolk", "Virginia Beach",
    "Williamsburg/James City County", "York",
  ],
  "Eastern Shore & Northern Neck": [
    "Accomack", "Caroline", "Essex", "King William", "King and Queen",
    "Lancaster", "Middlesex", "Northampton", "Northumberland",
    "Richmond County", "Westmoreland",
  ],
  "Southside Virginia": [
    "Amelia", "Brunswick", "Charlotte", "Danville", "Emporia",
    "Franklin City", "Franklin County", "Greensville", "Halifax",
    "Lunenburg", "Mecklenburg", "Nottoway", "Pittsylvania",
    "Prince Edward", "Southampton", "Surry", "Sussex",
  ],
  "Roanoke Area": [
    "Alleghany", "Botetourt", "Craig", "Floyd", "Giles",
    "Montgomery/Christiansburg", "Pulaski", "Radford",
    "Roanoke City", "Roanoke County", "Salem",
  ],
  "Southwest Virginia": [
    "Bland", "Bristol", "Buchanan", "Carroll", "Dickenson", "Galax",
    "Grayson", "Henry", "Lee", "Martinsville", "Patrick", "Russell",
    "Scott", "Smyth", "Tazewell", "Washington", "Wise/Norton", "Wythe",
  ],
}

const ALL_OPTION = { value: "", label: "All Regions" }

const REGION_OPTIONS = [
  ALL_OPTION,
  ...Object.keys(VA_REGIONS).map((name) => ({ value: name, label: name })),
]

const mapStore = (store) => ({
  courtFilter: store.trafficLookup.courtFilter,
  setCourtFilter: store.trafficLookup.setCourtFilter,
})

const CourtSelector = () => {
  const { courtFilter, setCourtFilter } = useInject(mapStore)

  return (
    <>
      <InputTitle>
        Region (Optional)
        <Spacer direction="width" mobile={11} desktop={11} />
      </InputTitle>
      <Spacer desktop={16} mobile={4} />
      <Dropdown
        autoFocus={false}
        blurInputOnSelect
        maxMenuHeight={140}
        value={
          courtFilter
            ? { value: courtFilter, label: courtFilter }
            : ALL_OPTION
        }
        onChange={(option) => setCourtFilter(option?.value || "")}
        options={REGION_OPTIONS}
        noLabel
        bold={false}
      />
    </>
  )
}

export default observer(CourtSelector)
